export const environment = {
    production: false,
    debug: false,
    apiUrl: '/api',
    applicationInsights: {
        instrumentationKey: '4bc02fee-0982-48d9-bab5-65857ee2214e'
    },
    msAuth: {
        issuer: 'https://login.microsoftonline.com/common/v2.0',
        clientId: '317650be-26e3-4008-ac7d-160eb1efa1dc',
        redirectUri: `${window.location.origin}/msal-auth`,
        scopes: ['api://317650be-26e3-4008-ac7d-160eb1efa1dc/user.read'],
        redirectToExternalEndSessionEndpointAfterLogout: false,
        redirectRoute: {
            afterAuthentication: ['/'],
            noAuthentication: ['/no-access'],
            failedAuthentication: ['/error']
        },
        // Use LocalStorage to allow same authentication across multiple browser tabs and persistence of tokens
        sessionStorageDriver: localStorage
    },
    features: {
        accessibleSteps: {
            enabled: true,
            showSetToDefaultButton: true // Useful for testing / debugging
        },
        apiProjectCreation: {
            enabled: true
        }
    }
};
